import { LeaderboardRakings } from "../../../Interfaces/FundraiserRole";
import "./Leaderboard.css";
import silhoutte from "../../../images/headshot-silhouette-30.png";

interface LeaderboardProps {
  ranking: LeaderboardRakings;
  currentParticipantID: number;
}

const Leaderboard: React.FC<LeaderboardProps> = ({
  ranking,
  currentParticipantID,
}) => {
  const currentParticipant = ranking.leaderboard.find(
    (entry) => entry.id === currentParticipantID,
  );
  const maxAmount =
    ranking.leaderboard.length > 0
      ? Math.max(...ranking.leaderboard.map((e) => e.amount_raised))
      : 0;

  return (
    <div className="participant-dashboard-leaderboard-container">
      <h2>Leaderboard</h2>
      {ranking.total_participants === 0 ? (
        <p>No participants found.</p>
      ) : (
        <>
          {ranking.leaderboard.map((entry, index) => (
            <div
              key={index}
              className={
                entry.id === currentParticipantID
                  ? "participant-dashboard-leaderboard-entry current-participant"
                  : "participant-dashboard-leaderboard-entry"
              }
            >
              <div className="leaderboard-rank">{index + 1}</div>
              <img src={entry.image || silhoutte} alt={entry.name} />
              <div className="leaderboard-info">
                {entry.id === currentParticipantID && (
                  <span className="leaderboard-you">You</span>
                )}
                <div className="leaderboard-name">{entry.name}</div>
              </div>
              <div className="leaderboard-progress">
                <div
                  className="leaderboard-bar"
                  style={{
                    width: `${(entry.amount_raised / maxAmount) * 100}%`,
                  }}
                />
              </div>
              <div className="leaderboard-amount">
                ${entry.amount_raised.toFixed(2)}
              </div>
            </div>
          ))}

          <div className="leaderboard-notification">
            <span className="notification-icon">⚡</span>
            <span>
              {ranking.position === 1 ? (
                <>"Congrats, you're in 1st place! Keep up the great work!"</>
              ) : (
                <>
                  Keep going! You're only{" "}
                  <b>${ranking.amount_to_next_rank.toFixed(2)}</b> away from
                  rank {ranking.position - 1}.
                </>
              )}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default Leaderboard;
